import React from "react";
import { Box, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Select, MenuItem, InputLabel, Divider } from "@mui/material";
import BASE_API_URL from '../../apis/index';
import { FaTimes } from "react-icons/fa";
import axios from "axios";

const LegalDocsSection = ({ formData, setFormData, handleChange, fieldValidation, setFieldValidation }) => {
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({ ...prev, [name]: files[0] }));
    };

    const handleGstBlur = async () => {
        if (!formData.gstNumber.trim()) return;

        try {
            const authToken = localStorage.getItem("authToken");

            const res = await axios.post(
                `${BASE_API_URL}/api/seller/company/check-gst-exist`,
                { gstNumber: formData.gstNumber },
                { headers: { Authorization: `Bearer ${authToken}` } }
            );

            if (res.data.exists) {
                setFieldValidation(prev => ({
                    ...prev,
                    gstNumber: {
                        status: 'error',
                        message: res.data.message
                    }
                }));
            } else {
                setFieldValidation(prev => ({
                    ...prev,
                    gstNumber: {
                        status: 'success',
                        message: ''
                    }
                }));
            }

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Box>
            <h5 className="mb-4">Statutory Details</h5>

            <div className="row gx-0">
                <div className="col-md-4 pe-1">
                    <TextField
                        className="w-100"
                        label={<> PAN Number <span style={{ color: "red" }}>*</span> </>}
                        name="panNumber"
                        value={formData.panNumber}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-4 px-1">
                    <TextField
                        className="w-100"
                        label={<> GST Number <span style={{ color: "red" }}>*</span> </>}
                        name="gstNumber"
                        value={formData.gstNumber}
                        onChange={handleChange}
                        onBlur={handleGstBlur}
                        error={fieldValidation.gstNumber.status === 'error'}
                        helperText={fieldValidation.gstNumber.message}
                        color={fieldValidation.gstNumber.status === 'success' ? 'success' : 'primary'}
                    />
                </div>
                {/* <div className="col-md-4 ps-1">
                    <TextField
                        className="w-100"
                        label="HSN/SAC Code"
                        name="hsnCode"
                        value={formData.hsnCode}
                        onChange={handleChange}
                    />
                </div> */}
                <div className="col-md-4 ps-1">
                    <TextField
                        className="w-100"
                        label={<> CIN / RC / LLP Codes </>}
                        name="cinCode"
                        value={formData.cinCode}
                        onChange={handleChange}
                    />
                </div>
            </div>


            {/* File Uploads */}
            <div className="row my-4 gy-3">
                <div className="col-md-4">
                    <FormLabel className="w-100">PAN Card Attachment <span className="text-danger">*</span></FormLabel>
                    {formData.existingPanDoc && typeof formData.existingPanDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingPanDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingPanDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingPanDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="panDoc"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div>

                {/* GST Doc */}
                <div className="col-md-4">
                    <FormLabel>GST Document Attachment <span className="text-danger">*</span></FormLabel>
                    {formData.existingGstDoc && typeof formData.existingGstDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingGstDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingGstDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingGstDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="gstDoc"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div>

                {/* CIN/RC/LLP Doc */}
                <div className="col-md-4">
                    <FormLabel className="w-100">CIN/RC/LLP Document</FormLabel>
                    {formData.existingCinDoc && typeof formData.existingCinDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingCinDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingCinDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingCinDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="cinDoc"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div>

                {/* CIN Doc */}
                {/* <div className="col-md-4">
                    <FormLabel className="w-100">CIN Document</FormLabel>
                    {formData.existingCinDoc && typeof formData.existingCinDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingCinDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingCinDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingCinDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="cinDoc"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div> */}

                {/* RC Doc */}
                {/* <div className="col-md-4">
                    <FormLabel className="w-100">RC Document</FormLabel>
                    {formData.existingRcDoc && typeof formData.existingRcDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingRcDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingRcDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingRcDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="rcDoc"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div> */}

                {/* LLP Doc */}
                {/* <div className="col-md-4">
                    <FormLabel className="w-100">LLP Certificate</FormLabel>
                    {formData.existingLlpDoc && typeof formData.existingLlpDoc === "string" ? (
                        <div className="mt-2 border d-flex align-items-center gap-3 p-2 rounded" style={{ width: "210px" }}>
                            <a href={`${BASE_API_URL}/uploads/user_comp_docs/${formData.existingLlpDoc}`} target="_blank" rel="noreferrer" className="text-decoration-none txt_color_secondary">
                                View Existing File
                            </a>
                            <Divider flexItem orientation="vertical" />
                            <button className="btn p-0" onClick={() => setFormData(prev => ({ ...prev, existingLlpDoc: null }))}>
                                <FaTimes onClick={() => setFormData(prev => ({ ...prev, existingLlpDoc: null }))} />
                            </button>
                        </div>
                    ) : (
                        <input
                            type="file"
                            name="llpCert"
                            accept="application/pdf"
                            onChange={handleFileChange}
                        />
                    )}
                </div> */}
            </div>

            {/* Vendor Status */}
            <FormControl className="mt-2 mb-3 w-100">
                <FormLabel>Vendor Status<span className="text-danger">*</span> : </FormLabel>
                <RadioGroup
                    row
                    name="vendorStatus"
                    value={formData.vendorStatus}
                    onChange={handleChange}
                >
                    <FormControlLabel value="Pvt Ltd" control={<Radio />} label="Pvt Ltd" />
                    <FormControlLabel value="Public Ltd" control={<Radio />} label="Public Ltd" />
                    <FormControlLabel value="PSU" control={<Radio />} label="PSU" />
                    <FormControlLabel value="SEZ" control={<Radio />} label="SEZ" />
                    <FormControlLabel value="Proprietorship" control={<Radio />} label="Proprietorship" />
                </RadioGroup>
            </FormControl>

            <div className="row gx-2">
                {/* Vendor Type */}
                <div className="col-md-6">
                    <FormControl className="w-100">
                        <InputLabel>Vendor Type<span className="text-danger">*</span> : </InputLabel>
                        <Select
                            name="vendorType"
                            value={formData.vendorType}
                            label="Vendor Type"
                            onChange={handleChange}
                        >
                            <MenuItem value="MSME">MSME</MenuItem>
                            <MenuItem value="Large Scale">Large Scale</MenuItem>
                            <MenuItem value="Government">Government</MenuItem>
                            <MenuItem value="Contract">Contract</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div className="col-md-6">
                    {/* Annual Turnover (Optional) */}
                    <TextField
                        label="Annual Turnover (Optional)"
                        name="annualTurnover"
                        value={formData.annualTurnover}
                        onChange={handleChange}
                        type="number"
                        className="w-100"
                    />
                </div>
            </div>
        </Box>
    );
};

export default LegalDocsSection;
